import * as React from "react";
import type { SVGProps } from "react";
const SvgDismissInSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.26 17.74c-.26 0-.51-.1-.71-.29a.996.996 0 0 1 0-1.41l4.038-4.038L6.56 7.97a.996.996 0 1 1 1.41-1.41L12 10.59l4.03-4.03a.996.996 0 1 1 1.41 1.41L13.41 12l4.03 4.03a.996.996 0 0 1-.71 1.7l.01.01c-.26 0-.51-.1-.71-.29l-4.033-4.037L7.97 17.44c-.2.2-.45.29-.71.29z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 22h12c2.21 0 4-1.79 4-4V6c0-2.21-1.79-4-4-4H6C3.79 2 2 3.79 2 6v12c0 2.21 1.79 4 4 4M4 6c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDismissInSquare;
